<script setup lang="ts">
import { save, close } from "ionicons/icons";
import {
  IonLabel,
  IonPage,
  IonItem,
  IonGrid,
  IonButton,
  IonLoading,
  IonIcon,
  IonRow,
  IonCol,
  IonFooter,
  IonContent,
} from "@ionic/vue";
import { useContextStore } from "@/stores/context";
import { reactive } from "vue";
import { editEvent } from "@/api/events";
import { handleError } from "@/views";

const contextStore = useContextStore();

const state = reactive({
  loading: false,
});

const readFile = async ($event: any) => {
  const target = $event.target as HTMLInputElement;
  if (target.files) {
    let file = target.files[0];
    const form = new FormData();
    form.append("file", file);
  }
  state.loading = true;
};

const openFileDialog = (file_input_id: string) => {
  document.getElementById(file_input_id)?.click();
};

const submit = async () => {
  state.loading = true;
  await editEvent({ ...contextStore.event }).catch((err) => {
    state.loading = false;
    handleError(err);
  });

  state.loading = true;
};
</script>
<template>
  <ion-page>
    <ion-content>
      <ion-item>
        <ion-label>
          <h1>Images</h1>
          <p>Set a form background and banner image.</p>
        </ion-label>
      </ion-item>
      <div class="ion-margin-top ion-margin-bottom">
        <ion-item>
          <ion-label position="stacked"> Logo image </ion-label>
          <div class="box" @click="openFileDialog('banner-file-upload')">
            <img
              :src="contextStore.event.logo_image"
              alt=""
              v-if="contextStore.event.logo_image"
            />
            <h6>TAP TO BROWSE FILE</h6>
            <p>Accepted files: JPG, JPEG, PNG, GIF</p>
            <input
              id="banner-file-upload"
              type="file"
              @change="readFile"
              style="display: none"
            />
          </div>
        </ion-item>
        <ion-item>
          <ion-label position="stacked"> Banner image </ion-label>
          <div class="box" @click="openFileDialog('banner-file-upload')">
            <img
              :src="contextStore.event.image"
              alt=""
              v-if="contextStore.event.image"
            />
            <h6>TAP TO BROWSE FILE</h6>
            <p>Accepted files: JPG, JPEG, PNG, GIF</p>
            <input
              id="banner-file-upload"
              type="file"
              @change="readFile"
              style="display: none"
            />
          </div>
        </ion-item>
        <ion-item>
          <ion-label position="stacked"> Background image </ion-label>
          <div class="box" @click="openFileDialog('background-file-upload')">
            <img
              :src="contextStore.event.background_image"
              alt=""
              v-if="contextStore.event.background_image"
            />
            <h6>TAP TO BROWSE FILE</h6>
            <p>Accepted files: JPG, JPEG, PNG, GIF</p>
            <input
              id="background-file-upload"
              type="file"
              @change="readFile"
              style="display: none"
            />
          </div>
        </ion-item>
      </div>
    </ion-content>

    <ion-footer>
      <div class="container">
        <section>
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-button expand="block" color="light" @click="submit()">
                  <ion-icon slot="start" :icon="close"></ion-icon>
                  Cancel
                </ion-button>
              </ion-col>
              <ion-col>
                <ion-button expand="block" color="success" @click="submit()">
                  <ion-icon slot="start" :icon="save"></ion-icon>
                  Save
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </section>
      </div>
    </ion-footer>
    <ion-loading :is-open="state.loading" message="Please wait...">
    </ion-loading>
  </ion-page>
</template>
